import { render, staticRenderFns } from "./ShipG6Layer.vue?vue&type=template&id=1031e7f3&scoped=true"
import script from "./ShipG6Layer.vue?vue&type=script&lang=js"
export * from "./ShipG6Layer.vue?vue&type=script&lang=js"
import style0 from "./ShipG6Layer.vue?vue&type=style&index=0&id=1031e7f3&prod&scoped=true&lang=css"
import style1 from "./ShipG6Layer.vue?vue&type=style&index=1&id=1031e7f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1031e7f3",
  null
  
)

export default component.exports